<template>
  <div class="header-wrap-top">
    <img src="/image/logo-top.svg" alt="clip" width="412" />

    <p>「Clip」をご利用頂きましてありがとうございました。</p>

    <p>このたび都合により2023年7月31日をもちまして「Clip」のすべてのサービスの提供を終了させていただきました。</p>

    <p>長きに渡りご愛顧をいただき、誠にありがとうございました。</p>

    <p>Copyright (c) Faber Company Inc. All Rights Reserved.</p>
  </div>
</template>

<style scoped>
div {
  padding: 50px;
}

.header-wrap-top::after {
  display: none;
}

div p {
  margin: 20px 0;
}
</style>

<script>
export default {
  layout: "none"
}
</script>